export default __webpack_public_path__ + "static/media/hamburger-menu-logo.70d0d2c8.png";